<template>
  <v-navigation-drawer :value="isDisputeDrawerOpen" class="drawer__right-side" :width="970" fixed right>
    <div class="resume__header">
      <v-row no-gutters :class="`resume__header ${$vuetify.breakpoint.mobile ? 'pa-3' : 'pa-8'}`">
        <v-col>
          <h3 class="text-left pt-1">
            {{ $t('detailsModal.title') }}
          </h3>
        </v-col>
        <v-col cols="1" class="text-right">
          <v-btn @click="setIsDisputeDrawerOpen(false)" icon>
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="drawer__content">
      <iframe
        v-if="isDisputeDrawerOpen && reportUrl"
        :src="reportUrl"
        referrerpolicy="no-referrer-when-downgrade"
        loading="lazy"
        allow="clipboard-write"
        class="iframe"
      />
    </div>
  </v-navigation-drawer>
</template>

<script>
// vuex
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'DisputeContent',

  // computed
  computed: {
    ...mapGetters(['isDisputeDrawerOpen', 'appointment', 'isAppointmentLoading']),

    canLoadReport() {
      return this.isDisputeDrawerOpen
        && !this.isAppointmentLoading
        && this.appointment
        && this.appointment.job_id
        && localStorage.getItem('access_token')
    },

    reportUrl() {
      if (!this.canLoadReport) return ''
      const accessToken = localStorage.getItem('access_token')
      return `${this.hCheckURL}/asset-report/view/${this.appointment.job_id}?accessToken=${accessToken}`
    },
  },

  // methods
  methods: {
    ...mapMutations(['setIsDisputeDrawerOpen']),

    handleKeyDown(event) {
      if (event.keyCode === 27 || event.key === 'Escape') {
        this.closeModal()
      }
    },

    disableBodyScroll() {
      document.querySelector('html').style.overflow = 'hidden'
    },

    enableBodyScroll() {
      document.querySelector('html').style.overflow = 'auto'
    },

    closeModal() {
      this.setIsDisputeDrawerOpen(false)
      this.$root.$emit('closeDisputeModal')
    }
  },

  // state
  data() {
    return {
      hCheckURL: process.env.VUE_APP_CHECKLIST_URL,
    }
  },

  // lifecycle
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
  },

  // watchers
  watch: {
    isDisputeDrawerOpen(newValue) {
      if (newValue) this.disableBodyScroll()
      else this.enableBodyScroll()
    },
  }
}
</script>

<style scoped>

.dispute-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;
}

.iframe {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;
}
</style>
